export function tvKey(e) {
  const k = e.keyCode;
  if (k === 37 || e.key === 'ArrowLeft') return 'left';
  if (k === 39 || e.key === 'ArrowRight') return 'right';
  if (k === 38 || e.key === 'ArrowUp') return 'up';
  if (k === 40 || e.key === 'ArrowDown') return 'down';
  if (k === 13 || e.key === 'Enter') return 'ok';
  if (k === 10009 || k === 461 || k === 8 || e.key === 'Escape' || e.key === 'Backspace' || e.key === 'GoBack' || e.key === 'XF86Back') return 'back';
  return null;
}
